import React from 'react';
import { Send } from 'lucide-react';

const AdminEmailsTab = ({ 
  emails, 
  formatDate 
}) => {
  return (
    <div className="admin-card full-width" data-testid="emails-tab">
      <h2><Send className="h-5 w-5" /> Sent Emails Log</h2>
      {emails.length > 0 ? (
        <div className="emails-list">
          {emails.map((email) => (
            <div key={email._id || email.resend_email_id || `${email.recipient_email}-${email.created_at}`} className="email-item" data-testid={`email-item-${email._id || email.resend_email_id}`}>
              <div className="email-header">
                <span className="email-recipient">{email.recipient_email || email.to_email}</span>
                <span className={`email-type-badge ${email.email_type}`}>
                  {email.email_type === 'magic_link' ? 'Magic Link' : 
                   email.email_type === 'receipt' ? 'Receipt' : 
                   email.email_type}
                </span>
              </div>
              <div className="email-meta">
                <span className="email-date">{formatDate(email.created_at || email.sent_at)}</span>
                {email.resend_email_id && (
                  <span className="email-id">ID: {email.resend_email_id.substring(0, 8)}...</span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="admin-empty">
          <Send className="h-12 w-12" />
          <p>No emails sent yet. Emails will appear here after users complete payments.</p>
        </div>
      )}
    </div>
  );
};

export default AdminEmailsTab;
